// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"325":"a5388446","394":"a5388446","440":"f2813ff5","449":"2357c1f4","681":"607409ee"}[chunkId] + ".chunk.css";
};